import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { EntitlementsService } from '../Services/entitlements.service';

/**
 * Structural directive: *ssRequiresEntitlement="'live_wall'" or *ssRequiresEntitlement="['a','b']"
 * scope: company (default) | user
 * mode: all (default) | any
 */
@Directive({
  selector: '[ssRequiresEntitlement]',
  standalone: false,
})
export class SsRequiresEntitlementDirective implements OnInit, OnDestroy {
  @Input('ssRequiresEntitlement') required: string | string[] = [];
  @Input() ssRequiresScope: 'company' | 'user' = 'company';
  @Input() ssRequiresMode: 'all' | 'any' = 'all';

  private sub?: Subscription;

  constructor(
    private entitlements: EntitlementsService,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.entitlements.syncFromSession();
    this.sub = this.entitlements.stateChanged$.subscribe(() => this.render());
    this.render();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private render(): void {
    this.viewContainer.clear();
    if (this.isAllowed()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  private isAllowed(): boolean {
    const keys = this.normalizeKeys(this.required);
    if (!keys.length) {
      return true;
    }
    if (this.ssRequiresScope === 'user') {
      return this.ssRequiresMode === 'any'
        ? this.entitlements.hasAnyUser(keys)
        : keys.every((k) => this.entitlements.hasUser(k));
    }
    return this.ssRequiresMode === 'any'
      ? this.entitlements.hasAnyCompany(keys)
      : keys.every((k) => this.entitlements.hasCompany(k));
  }

  private normalizeKeys(raw: string | string[]): string[] {
    if (!raw) {
      return [];
    }
    return Array.isArray(raw) ? raw.map(String) : [String(raw)];
  }
}
